/*
 * Copyright (c) 2023. Haodong JU
 */

import hillo from 'hillo'
import IKDataEntity from '@/plugins/EntityFrameWork/IKDataEntity'
import dayjs from 'dayjs'
import Servant from '@/model/dataLayer/api/tableAndPerson/Servant'
// import store from '../store'

const entity = {
  id: {
    formConfig: {
      required: false
    },
    header: false
  },
  servantName: {
    displayName: 'staff',
    type: IKDataEntity.Types.Option,
    formConfig: {
      type: {
        selectItems: async () => await Servant.getList(true),
        itemText: 'name',
        itemValue: 'name',
        multiple: true
      }
    }
  },
  fromDateTime: {
    displayName: 'ShiftStart'
  },
  toDateTime: {
    displayName: 'ShiftEnd'
  },
  workMinute: {
    displayName: 'WorkTimeInMinute'
  },
  workHour: {
    displayName: 'WorkTimeInHour'
  },
  currentHourlyWage: {
    displayName: 'ShiftHourlyRate'
  },
  correction: {
    displayName: 'ShiftTrackingCard'
  },
  note: {}
}
const config = {
  edit: function (item) {
    return hillo.post('Servant.php?op=updateServantClockInRecord', item)
  },
  load: async function (filter) {
    const [fromDateTime, toDateTime] = [dayjs(filter[0].dateFilter[0]).format('YYYY-MM-DD') + ' 04:00:00', dayjs(filter[0].dateFilter[1]).add(1, 'day').format('YYYY-MM-DD') + ' 03:59:59']
    return (await hillo.get('Servant.php?op=getServantClockInRecords', {
      fromDateTime,
      toDateTime
    })).content.map(it => {
      it.workHour = (it.workMinute / 60).toFixed(2)
      return it
    })
  }
}

export default IKDataEntity.ModelFactory(entity, config)

export async function servantClockCorrect (item) {
  if (!item.currentHourlyWage) {
    delete item.currentHourlyWage
  }
  console.log(item, 'item')
  return (await hillo.post('Servant.php?op=servantClockCorrect', {
    ...item
  }))
}
